module.exports = __webpack_public_path__ + "img/Antonia&Stephan-06.1bafc62c.jpg";